import { zodResolver } from '@hookform/resolvers/zod';
import { FormProvider, useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { z } from 'zod';
import { getFeatureFlags } from 'core/userContext/selectors';
import { BaseSendEditorProps, SendNodeResources } from '../BaseSendEditor.types';
import {
  checkIsSendEditorImprovementsEnabled,
  consolidateCampaignData,
  getLabelNames,
} from '../BaseSendEditor.utils';

// Will need to update this as we move all fields to RHF in WF-6918
const BaseCampaignSchema = z.object({
  // labels: z.string().array().optional(),
  // name: z.string().min(1, 'Name is required'),
});

const NewBaseCampaignSchema = z.object({
  name: z.string().optional(),
  labels: z.string().array().optional(),
});

export interface CampaignFormProviderProps extends BaseSendEditorProps {
  schema?: z.AnyZodObject;
}

export const CampaignFormProvider = ({
  children,
  schema = z.object({}),
  messageMedium,
  nodeData,
  resources,
}: CampaignFormProviderProps) => {
  const featureFlags = useSelector(getFeatureFlags);
  const isSendEditorImprovementsEnabled = checkIsSendEditorImprovementsEnabled(
    messageMedium,
    featureFlags,
  );
  const { name, labels } = consolidateCampaignData(nodeData, resources as SendNodeResources);
  const combinedSchema = (
    isSendEditorImprovementsEnabled ? NewBaseCampaignSchema : BaseCampaignSchema
  ).merge(schema);

  type FormSchemaType = Required<z.infer<typeof schema>>;
  const methods = useForm<FormSchemaType>({
    mode: 'all',
    resolver: zodResolver(combinedSchema),
    shouldUnregister: true,
    ...(isSendEditorImprovementsEnabled && {
      defaultValues: {
        ...(name && { name }),
        ...(labels && { labels: getLabelNames(labels) }),
      },
    }),
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
